const RECHARGE_URL = 'https://checkout.rechargeapps.com/r/checkout';

/**
 * Used to create a Recharge checkout URL
 *
 * Based on: https://support.rechargepayments.com/hc/en-us/articles/360008682694-Redirect-to-checkout-from-AJAX-cart
 *
 * @param {*} customerId
 * @param {*} customerEmail
 * @param {*} cartToken
 * @param {*} shopDomain
 */
export const createRechargeCheckoutURL = (
  customerId,
  customerEmail,
  cartToken,
  shopDomain
) => {
  const paramString = Object.entries({
    customer_id: customerId,
    customer_email: customerEmail,
    cart_token: cartToken,
    myshopify_domain: shopDomain
  })
    .map((entry) => entry.map(encodeURIComponent).join('='))
    .join('&');

  return `${RECHARGE_URL}?${paramString}`;
};
